import * as React from "react";
import Button from "@mui/material/Button/Button";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogContentText from "@mui/material/DialogContentText/DialogContentText";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import Dialog from "@mui/material/Dialog/Dialog";
import {HOME_ROUTE} from "../router/routes";
import {useNavigate} from "react-router";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Dialog open={true}>
      <DialogTitle>Page not found!</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Sorry, but there's no page with this url or you do not have access to it.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          id={'button_home'}
          variant="contained"
          color="primary"
          onClick={() => navigate(HOME_ROUTE.path)}
        >
          Home
        </Button>
      </DialogActions>
    </Dialog>
  );
}
